import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Report from 'powerbi-report-component';

import { postData } from '../dataLib';

import { Button } from '@material-ui/core';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    //toolbar: theme.mixins.toolbar,;
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class IniMiMuro extends Component {

    constructor(props) {
        super(props);

        this.report = null;

        this.state = {
            token: ''
        }
    }

    handleReportLoad = (report) => {
        this.report = report; // get the report object from callback and store it.
    }

    handleReportRender = (report) => {
        this.report = report; // get the report object from callback and store it.
    }

    componentDidMount = () => {

        if (this.props.user) {

            postData(
                'https://ilusiona-redemptionreports-prod.azurewebsites.net/api/PBI/CreateToken',
                (response) => {
                    this.setState({ ...this.state, token: response.data })
                },
                () => {
                    this.props.openDialog('SimpleMessage', {
                        message: 'ERROR updating arqueo'
                    }, 'error-create-token', false, 'sm');
                },
                {
                    workspaceId: '776470de-5903-4f74-b7ea-6f7563f7932e',
                    reportId: '73040bb6-041c-4051-9897-4d9c1846e42c'
                },
                this.props.user,
                true
            );
        }

    }

    // const centros = [0, 4, 5].includes(perfil) ?
    // this.props.centros.filter(c => c.activo === 1)
    // : this.props.centros.filter(c => c.id === this.props.userProfile.selectedCentroProfile.centroId);

    render() {

        const { classes } = this.props;

        const reportStyle = {
            height: 800
        };

        if (!this.props.user) {
            return (
                <div className={classes.root}>
                    <div className={classes.toolbar} />
                    <div>Please login</div>
                </div>
            );
        }
        else {

            let centrosFilter = '';

            if (this.props.userProfile) {

                const perfil = this.props.userProfile.selectedCentroProfile.iPerfil;

                if ([0, 4, 5, 17, 20].includes(perfil)) {
                    centrosFilter = '&filter=BI_Centro/id ne -1';
                }
                else {

                    const usuarioCentros = this.props.userProfile.profile.usuarioCentro;

                    if (usuarioCentros.length > 0) {
                        centrosFilter = '&filter=BI_Centro/id in (' + usuarioCentros[0].centro.id;
                        for (var i = 1; i < usuarioCentros.length; i++) {
                            centrosFilter += ',' + usuarioCentros[i].centro.id;
                        }
                        centrosFilter += ')';
                    }
                    else {
                        centrosFilter = '&filter=BI_Centro/id eq -1';
                    }
                }

            }

            return (
                <div className={classes.root}>
                    <div className={classes.toolbar} />
                    {/* <div>Aqui aparecerán las notificaciones importantes para este usuario</div> */}
                    {/* <object data="https://www.ilusiona.com" width="100%" height="800" type="text/html">Alternative Content</object> */}
                    {process.env.REACT_APP_CLIENT.includes('Ilusiona') ?
                        this.state.token === '' || !this.props.userProfile ?
                            <div>Información/resumen para este usuario</div>
                            :
                            <div>
                                <Report
                                    embedType="report"
                                    tokenType="Embed"
                                    accessToken={this.state.token}
                                    embedUrl={"https://app.powerbi.com/reportEmbed?reportId=73040bb6-041c-4051-9897-4d9c1846e42c&groupId=776470de-5903-4f74-b7ea-6f7563f7932e&$filterPaneEnabled=False" + centrosFilter}
                                    embedId="73040bb6-041c-4051-9897-4d9c1846e42c"
                                    permissions="View"
                                    style={reportStyle}
                                    onLoad={this.handleReportLoad}
                                    onRender={this.handleReportRender}

                                />
                                <Button variant="contained" color="secondary" className={classes.button} onClick={() => {
                                    if (this.report) {
                                        //this.report.fullscreen();
                                        this.report.fullscreen();
                                    }
                                }}>
                                    Pantalla completa
                            </Button>
                                <Button variant="contained" color="secondary" className={classes.button} onClick={() => {
                                    if (this.report) {
                                        //this.report.fullscreen();
                                        this.report.print();
                                    }
                                }}>
                                    Imprimir
                            </Button>
                            </div>
                        :
                        ''
                    }
                </div>
            );
        }
    };

};

IniMiMuro.propTypes = {
    user: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        userProfile: state.userProfile
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(IniMiMuro));